import { ClienteEncabezado } from "../cliente/ClienteEncabezado";
import { Producto } from "./Producto";
import { UsuarioAerovale } from "./UsuarioAerovale";

export class AerovaleFacturaAnticipada {
  litros: number;
  producto: Producto;
  cliente: ClienteEncabezado;
  comentarios: string;
  fechaHoraVigenciaHasta: string;
  codigoAeroplanta: string;
  operadorDTO: UsuarioAerovale;
}
  